// eslint-disable-next-line unused-imports/no-unused-vars
export function embedGQLFields(fields) {
    return `
    author
    author_url
    description
    html
    id
    provider_name
    thumbnail_height
    thumbnail_url
    thumbnail_width
    title
    type
    url  
  `;
}
